/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditsToCompany
 */
export interface CreditsToCompany {
    /**
     * Amount of credits added to the selected company
     * @type {number}
     * @memberof CreditsToCompany
     */
    amount: number;
}

export function CreditsToCompanyFromJSON(json: any): CreditsToCompany {
    return CreditsToCompanyFromJSONTyped(json, false);
}

export function CreditsToCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditsToCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

export function CreditsToCompanyToJSON(value?: CreditsToCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
    };
}


